
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="Long text destroys layout" fileName="long-word.md" />
        <demo-block>
        <div><p>1、Too much text in a cell destroys the layout,This can be controlled by style <a href="https://developer.mozilla.org/zh-CN/docs/Web/CSS/word-break">word-break</a> <br>2、You can also use it with <a href="#/en/doc/table/cell-ellipsis">Cell Ellipsis</a></p>
</div>
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;div&gt;
        word-break：
        &lt;el-radio-group size=&quot;small&quot; v-model=&quot;wordBreak&quot;&gt;
            &lt;el-radio-button label=&quot;normal&quot;&gt;normal&lt;/el-radio-button&gt;
            &lt;el-radio-button label=&quot;keep-all&quot;&gt;keep-all&lt;/el-radio-button&gt;
            &lt;el-radio-button label=&quot;break-all&quot;&gt;break-all&lt;/el-radio-button&gt;
            &lt;el-radio-button label=&quot;break-word&quot;&gt;break-word&lt;/el-radio-button&gt;
        &lt;/el-radio-group&gt;
        &lt;br /&gt;
        &lt;br /&gt;
        &lt;ve-table
            :style=&quot;{'word-break':wordBreak}&quot;
            :columns=&quot;columns&quot;
            :table-data=&quot;tableData&quot;
            :border-around=&quot;true&quot;
            :border-x=&quot;true&quot;
            :border-y=&quot;true&quot;
        /&gt;
    &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
    export default {
        data() {
            return {
                wordBreak: &quot;normal&quot;,
                columns: [
                    {
                        field: &quot;name&quot;,
                        key: &quot;a&quot;,
                        title: &quot;Name 40%&quot;,
                        width: &quot;40%&quot;,
                    },
                    { field: &quot;date&quot;, key: &quot;b&quot;, title: &quot;Tel 20%&quot;, width: &quot;20%&quot; },
                    {
                        field: &quot;hobby&quot;,
                        key: &quot;c&quot;,
                        title: &quot;Hobby 20%&quot;,
                        width: &quot;20%&quot;,
                        /*   ellipsis: {
              showTitle: true,
              lineClamp: 5,
            }, */
                    },
                    {
                        field: &quot;address&quot;,
                        key: &quot;d&quot;,
                        title: &quot;Address 20%&quot;,
                        width: &quot;20%&quot;,
                    },
                ],
                tableData: [
                    {
                        name: &quot;John&quot;,
                        date: &quot;1900-05-20&quot;,
                        hobby: &quot;Honorificabilitudinitatibus califragilisticexpialidocious Taumatawhakatangihangakoauauotamateaturipukakapikimaungahoronukupokaiwhenuakitanatahu 大江东去浪淘尽千古风流人物故垒西边人道是三国周郎赤壁乱石穿空惊涛拍岸卷起千堆雪江山如画一时多少豪杰&quot;,
                        address: &quot;No.1 Century Avenue, Xiamen&quot;,
                    },
                    {
                        name: &quot;Dickerson&quot;,
                        date: &quot;1910-06-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Beijing&quot;,
                    },
                    {
                        name: &quot;Larsen&quot;,
                        date: &quot;2000-07-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Chongqing&quot;,
                    },
                    {
                        name: &quot;Geneva&quot;,
                        date: &quot;2010-08-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Xiamen&quot;,
                    },
                    {
                        name: &quot;Jami&quot;,
                        date: &quot;2020-09-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Shenzhen&quot;,
                    },
                ],
            };
        },
    };
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        null
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_vm._v("\n        word-break：\n        "),_c('el-radio-group',{attrs:{"size":"small"},model:{value:(_vm.wordBreak),callback:function ($$v) {_vm.wordBreak=$$v},expression:"wordBreak"}},[_c('el-radio-button',{attrs:{"label":"normal"}},[_vm._v("normal")]),_vm._v(" "),_c('el-radio-button',{attrs:{"label":"keep-all"}},[_vm._v("keep-all")]),_vm._v(" "),_c('el-radio-button',{attrs:{"label":"break-all"}},[_vm._v("break-all")]),_vm._v(" "),_c('el-radio-button',{attrs:{"label":"break-word"}},[_vm._v("break-word")])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('ve-table',{style:({'word-break':_vm.wordBreak}),attrs:{"columns":_vm.columns,"table-data":_vm.tableData,"border-around":true,"border-x":true,"border-y":true}})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data() {
            return {
                wordBreak: "normal",
                columns: [
                    {
                        field: "name",
                        key: "a",
                        title: "Name 40%",
                        width: "40%",
                    },
                    { field: "date", key: "b", title: "Tel 20%", width: "20%" },
                    {
                        field: "hobby",
                        key: "c",
                        title: "Hobby 20%",
                        width: "20%",
                        /*   ellipsis: {
              showTitle: true,
              lineClamp: 5,
            }, */
                    },
                    {
                        field: "address",
                        key: "d",
                        title: "Address 20%",
                        width: "20%",
                    },
                ],
                tableData: [
                    {
                        name: "John",
                        date: "1900-05-20",
                        hobby: "Honorificabilitudinitatibus califragilisticexpialidocious Taumatawhakatangihangakoauauotamateaturipukakapikimaungahoronukupokaiwhenuakitanatahu 大江东去浪淘尽千古风流人物故垒西边人道是三国周郎赤壁乱石穿空惊涛拍岸卷起千堆雪江山如画一时多少豪杰",
                        address: "No.1 Century Avenue, Xiamen",
                    },
                    {
                        name: "Dickerson",
                        date: "1910-06-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Beijing",
                    },
                    {
                        name: "Larsen",
                        date: "2000-07-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Chongqing",
                    },
                    {
                        name: "Geneva",
                        date: "2010-08-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Xiamen",
                    },
                    {
                        name: "Jami",
                        date: "2020-09-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Shenzhen",
                    },
                ],
            };
        },
    };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      
    </style>
  